(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
  const template = document.getElementById('mobile-product-reviews-template');
  if (!template) return;
  const roots = new WeakSet();
  const photoRequests = new Map();
  const filterStates = new WeakMap();
  const decodedPhotos = new Map();
  const warmingStrips = new WeakSet();
  function loadUncroppedThumbnail(image) {
    if (!image) return;
    const source = new URL(image.src);
    if (source.origin === 'https://cdn.helpfulcrowdcdn.com' && /\.thumb\.jpg$/.test(source.pathname)) {
      source.pathname = source.pathname.replace(/\.thumb\.jpg$/, '.large.jpg');
    } else if (source.origin === 'https://res.cloudinary.com' && source.pathname.startsWith('/helpfulcrowd/image/upload/')) {
      source.pathname = source.pathname.replace(/\/c_fill,g_auto,h_(?:100|480),w_(?:180|360)\//, '/w_1100/');
    }
    if (source.href === image.src) return;
    image.setAttribute('data-lmr-photo-loading', '');
    const finish = () => {
      image.removeAttribute('data-lmr-photo-loading');
      image.removeEventListener('load', finish);
      image.removeEventListener('error', finish);
    };
    image.addEventListener('load', finish);
    image.addEventListener('error', finish);
    image.src = source.href;
  }
  function preparePhoto(src) {
    if (!decodedPhotos.has(src)) {
      const image = new Image();
      image.src = src;
      const ready = image.decode().then(() => src).catch(error => { decodedPhotos.delete(src); throw error; });
      decodedPhotos.set(src, ready);
    }
    return decodedPhotos.get(src);
  }
  const photoWarmup = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const media = entry.target;
      if (!entry.isIntersecting || warmingStrips.has(media)) return;
      if (navigator.connection?.saveData) { photoWarmup.unobserve(media); return; }
      warmingStrips.add(media);
      const source = media.querySelector('[data-gallery-src]')?.dataset.gallerySrc;
      const visible = [...media.querySelectorAll('.hc-media__medium')].slice(0, 4).map(node => {
        const image = node.querySelector('img');
        return { node, id: node.dataset.id, image, original: image?.getAttribute('src') };
      });
      const stripChanged = () => {
        const current = [...media.querySelectorAll('.hc-media__medium')].slice(0, 4);
        return media.querySelector('[data-gallery-src]')?.dataset.gallerySrc !== source || current.length !== visible.length || visible.some(({ node, id, image, original }, index) => current[index] !== node || node.dataset.id !== id || node.querySelector('img') !== image || image?.getAttribute('src') !== original);
      };
      loadPhotos(media).then(async photos => {
        if (!media.isConnected || stripChanged()) return;
        const results = await Promise.allSettled(visible.map(async snapshot => {
          const { node, id, image, original } = snapshot;
          if (!id || !image) return;
          const matches = photos.filter(photo => {
            try {
              const full = new URL(photo.src);
              const thumbnail = new URL(original);
              const filename = decodeURIComponent(full.pathname.split('/').pop());
              const sameId = filename.replace(/\.(?:(?:thumb|large)\.)?(?:jpe?g|png|webp|avif)$/i, '') === id;
              const legacyPath = full.pathname.match(/\/v\d+\/(.+)$/)?.[1];
              const sameLegacyImage = full.origin === 'https://res.cloudinary.com' && thumbnail.origin === full.origin && full.pathname.startsWith('/helpfulcrowd/image/upload/') && thumbnail.pathname.startsWith('/helpfulcrowd/image/upload/') && legacyPath && thumbnail.pathname.match(/\/v\d+\/(.+)$/)?.[1] === legacyPath;
              return sameId || sameLegacyImage;
            } catch { return false; }
          });
          if (matches.length !== 1 || image.src === matches[0].src) return;
          const src = await preparePhoto(matches[0].src);
          if (media.isConnected && media.contains(node) && node.contains(image) && node.dataset.id === id && image.getAttribute('src') === original && media.querySelector('[data-gallery-src]')?.dataset.gallerySrc === source) {
            image.src = src;
            snapshot.original = image.getAttribute('src');
          }
        }));
        if (!stripChanged() && results.every(result => result.status === 'fulfilled')) photoWarmup.unobserve(media);
      }).catch(() => {}).finally(() => {
        warmingStrips.delete(media);
        if (!media.isConnected) photoWarmup.unobserve(media);
        else if (stripChanged()) { photoWarmup.unobserve(media); photoWarmup.observe(media); }
      });
    });
  }, { rootMargin: '400px' });
  async function loadPhotos(media) {
    const source = media?.querySelector('[data-gallery-src]')?.dataset.gallerySrc;
    if (!source) return [];
    if (!photoRequests.has(source)) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      const request = fetch(source, { signal: controller.signal, credentials: 'omit' })
        .then(response => { if (!response.ok) throw new Error('Photo request failed'); return response.json(); })
        .then(payload => {
          if (!Array.isArray(payload)) throw new Error('Invalid photo response');
          return payload.filter(photo => photo.type === 'image' && /^https:\/\//.test(photo.src));
        })
        .catch(error => { photoRequests.delete(source); throw error; })
        .finally(() => clearTimeout(timeout));
      photoRequests.set(source, request);
    }
    return photoRequests.get(source);
  }
  function reviewCard(photo, prefix) {
    const parsed = new DOMParser().parseFromString(photo.txt || '', 'text/html');
    const card = parsed.querySelector('.hc-widget-card[data-id]');
    if (!card) throw new Error('Review data unavailable');
    const id = card.dataset.id;
    const allowed = new Set(['SECTION', 'HEADER', 'DIV', 'ARTICLE', 'P', 'SPAN', 'TIME', 'STRONG', 'EM', 'B', 'I', 'BR', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'A', 'SVG', 'G', 'PATH', 'RECT', 'INPUT', 'LABEL']);
    for (const node of [card, ...card.querySelectorAll('*')]) {
      if (!allowed.has(node.tagName.toUpperCase())) { node.remove(); continue; }
      const fill = node.style?.fill;
      for (const attribute of [...node.attributes]) {
        const name = attribute.name.toLowerCase();
        if (!['class', 'datetime', 'title', 'viewbox', 'd', 'fill', 'fill-rule', 'transform', 'width', 'height', 'data-fill-color', 'type', 'checked', 'id', 'for', 'href'].includes(name)) node.removeAttribute(attribute.name);
      }
      if (fill && /^(#[a-f0-9]{3,8}|rgba?\([\d\s.,%]+\)|none)$/i.test(fill)) node.style.fill = fill;
      if (node.hasAttribute('href') && !/^https:\/\//.test(node.getAttribute('href'))) node.removeAttribute('href');
      if (node.hasAttribute('id')) node.id = prefix + node.id;
      if (node.hasAttribute('for')) node.setAttribute('for', prefix + node.getAttribute('for'));
      if (node.tagName === 'INPUT' && node.type !== 'checkbox') node.remove();
    }
    card.dataset.reviewId = id;
    const item = document.createElement('li');
    item.className = 'hc-card__item';
    item.append(card);
    return { id, item, card };
  }
  function createFilter(root, toolbar, nativeList, media) {
    const all = toolbar.querySelector('.lmr-all-reviews');
    const withPhotos = toolbar.querySelector('.lmr-photo-button');
    const results = template.content.querySelector('.lmr-filter-results').cloneNode(true);
    nativeList.after(results);
    const status = results.querySelector('[role="status"]');
    const output = results.querySelector('ul');
    let version = 0;
    let built = false;
    function reset() {
      version++;
      all.setAttribute('aria-pressed', 'true');
      withPhotos.setAttribute('aria-pressed', 'false');
      results.hidden = true;
      results.removeAttribute('aria-busy');
      const currentList = root.querySelector('.hc-reviews-tab__list');
      if (currentList) currentList.hidden = false;
    }
    all.addEventListener('click', reset);
    withPhotos.addEventListener('click', async () => {
      const current = ++version;
      all.setAttribute('aria-pressed', 'false');
      withPhotos.setAttribute('aria-pressed', 'true');
      const currentList = root.querySelector('.hc-reviews-tab__list');
      if (currentList) currentList.hidden = true;
      results.hidden = false;
      if (built) return;
      results.setAttribute('aria-busy', 'true');
      status.hidden = false;
      status.textContent = status.dataset.loading;
      try {
        const photos = await loadPhotos(media);
        if (current !== version || !root.isConnected) return;
        const reviews = new Map();
        photos.forEach((photo, index) => {
          const review = reviewCard(photo, `lmr-${root.dataset.hcId}-`);
          if (!reviews.has(review.id)) {
            const strip = document.createElement('div');
            strip.className = 'lmr-card-photos';
            const author = review.card.querySelector('.hc-review > section');
            if (author) author.before(strip); else review.card.append(strip);
            reviews.set(review.id, { ...review, strip });
          }
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'lmr-card-photo';
          button.setAttribute('aria-label', `${template.content.querySelector('.lmr-photo-heading h3').textContent.trim()} ${index + 1}`);
          const image = document.createElement('img');
          image.alt = '';
          image.width = 76;
          image.height = 96;
          image.loading = 'lazy';
          image.src = photo.src.replace('w_1100/', 'w_360/');
          button.append(image);
          button.addEventListener('click', () => openPhotos(root, media, index, button));
          reviews.get(review.id).strip.append(button);
        });
        output.replaceChildren(...[...reviews.values()].map(review => review.item));
        built = true;
        status.hidden = reviews.size > 0;
        status.textContent = status.dataset.empty;
      } catch (error) {
        if (current === version) status.textContent = status.dataset.error;
      } finally {
        if (current === version) results.removeAttribute('aria-busy');
      }
    });
    filterStates.set(root, { reset });
  }
  const dateFormat = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { day: 'numeric', month: 'short', year: 'numeric' });
  async function openPhotos(root, media, index, trigger) {
    const source = media.querySelector('[data-gallery-src]')?.dataset.gallerySrc;
    if (!source) return;
    const dialog = template.content.querySelector('.lmr-dialog').cloneNode(true);
    dialog.style.setProperty('--lmr-surface', template.dataset.surface);
    dialog.style.setProperty('--lmr-border', template.dataset.border);
    const status = dialog.querySelector('[role="status"]');
    const figure = dialog.querySelector('figure');
    // Block background gestures without changing the document's layout or scroll container.
    const blockBackgroundScroll = event => {
      if (!dialog.contains(event.target) || event.target === dialog) event.preventDefault();
    };
    document.addEventListener('touchmove', blockBackgroundScroll, { passive: false });
    document.addEventListener('wheel', blockBackgroundScroll, { passive: false });
    const previousScroll = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
    document.body.append(dialog);
    dialog.addEventListener('close', () => {
      document.removeEventListener('touchmove', blockBackgroundScroll);
      document.removeEventListener('wheel', blockBackgroundScroll);
      dialog.remove();
      trigger?.focus({ preventScroll: true });
      window.scrollTo(previousScroll);
      requestAnimationFrame(() => window.scrollTo(previousScroll));
    }, { once: true });
    function closePhotos() {
      if (dialog.classList.contains('lmr-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
      dialog.classList.add('lmr-closing');
      const fallback = setTimeout(() => dialog.close(), 220);
      dialog.addEventListener('animationend', event => {
        if (event.animationName !== 'lmr-sheet-exit') return;
        clearTimeout(fallback);
        dialog.close();
      });
    }
    dialog.querySelector('.lmr-dialog-close').addEventListener('click', closePhotos);
    dialog.addEventListener('cancel', event => { event.preventDefault(); closePhotos(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) closePhotos(); });
    status.textContent = status.dataset.loading;
    dialog.showModal();
    dialog.querySelector('.lmr-dialog-close').focus({ preventScroll: true });
    window.scrollTo(previousScroll);
    requestAnimationFrame(() => window.scrollTo(previousScroll));
    const initialThumbnail = media.querySelectorAll('.hc-media__medium img')[index];
    if (initialThumbnail?.currentSrc) {
      figure.querySelector('img').src = initialThumbnail.currentSrc;
      figure.hidden = false;
      figure.querySelectorAll('button').forEach(button => { button.disabled = true; });
    }
    try {
      const photos = await loadPhotos(media);
      if (!dialog.isConnected) return;
      if (!photos.length) throw new Error('No photos available');
      let current = Math.min(index, photos.length - 1);
      const previous = dialog.querySelector('.lmr-photo-prev');
      const next = dialog.querySelector('.lmr-photo-next');
      const thumbnails = dialog.querySelector('.lmr-photo-thumbnails');
      const thumbnailButtons = [];
      let imageVersion = 0;
      function show() {
        const photo = photos[current];
        const text = new DOMParser().parseFromString(photo.txt || '', 'text/html');
        const title = text.querySelector('.hc-review__title')?.textContent.trim() || '';
        const author = text.querySelector('.hc-author__text .bold')?.textContent.trim() || '';
        const image = figure.querySelector('img');
        const version = ++imageVersion;
        // Keep the previous decoded image visible until the next one is ready.
        preparePhoto(photo.src).then(src => {
          if (dialog.isConnected && version === imageVersion) image.src = src;
        }).catch(() => {
          if (dialog.isConnected && version === imageVersion) { status.hidden = false; status.textContent = status.dataset.error; }
        });
        if (!image.getAttribute('src')) {
          const thumbnail = media.querySelectorAll('.hc-media__medium img')[current];
          if (thumbnail?.currentSrc) image.src = thumbnail.currentSrc;
        }
        [photos[current - 1], photos[current + 1]].filter(Boolean).forEach(neighbor => preparePhoto(neighbor.src).catch(() => {}));
        image.alt = [dialog.querySelector('h2').textContent, author].filter(Boolean).join(' — ');
        figure.querySelector('figcaption').textContent = [title, author].filter(Boolean).join(' — ');
        dialog.querySelector('.lmr-photo-position').textContent = `${current + 1} / ${photos.length}`;
        previous.disabled = current === 0;
        next.disabled = current === photos.length - 1;
        thumbnailButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
        const active = thumbnailButtons[current];
        if (active) thumbnails.scrollTo({ left: active.offsetLeft - thumbnails.offsetLeft - (thumbnails.clientWidth - active.offsetWidth) / 2, behavior: 'instant' });
        status.hidden = true;
      }
      photos.forEach((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lmr-photo-thumbnail';
        button.setAttribute('aria-label', `${dialog.querySelector('h2').textContent} ${index + 1}`);
        button.setAttribute('aria-pressed', String(index === current));
        const image = document.createElement('img');
        image.src = photo.src.replace('w_1100/', 'w_180/');
        image.alt = '';
        image.width = 90;
        image.height = 120;
        // Created only when the viewer opens; native lazy loading can stall in a top-layer dialog.
        image.loading = 'eager';
        button.append(image);
        button.addEventListener('click', () => { current = index; show(); });
        thumbnails.append(button);
        thumbnailButtons.push(button);
      });
      previous.addEventListener('click', () => { if (current > 0) { current--; show(); } });
      next.addEventListener('click', () => { if (current < photos.length - 1) { current++; show(); } });
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') previous.click();
        if (event.key === 'ArrowRight') next.click();
      });
      figure.querySelector('img').addEventListener('error', () => { status.hidden = false; status.textContent = status.dataset.error; });
      status.hidden = true;
      figure.hidden = false;
      dialog.querySelector('nav').hidden = false;
      show();
    } catch (error) {
      if (dialog.isConnected) status.textContent = status.dataset.error;
    }
  }
  const reviewPages = new WeakMap();
  let reviewListId = 0;
  const reviewsPerPage = 3;

  function reviewCards(list) {
    return [...list.children].filter(item => item.classList.contains('hc-card__item'));
  }

  function nativePage(paging) {
    return Number(paging?.querySelector('.active .page-link')?.textContent.trim() || 1);
  }

  // HelpfulCrowd returns its HTML inside a JavaScript string. Read that string
  // as data only; never execute the response or replace the surrounding widget.
  function reviewPageMarkup(source) {
    const literal = source.match(/\bvar html = ("(?:\\.|[^"\\])*")/);
    if (!literal) throw new Error('Unrecognized review response');
    const json = literal[1].replace(/\\(?:u[\da-fA-F]{4}|[^])/g, escape => {
      return ["\\'", '\\`', '\\$'].includes(escape) ? escape.slice(1) : escape;
    });
    return new DOMParser().parseFromString(JSON.parse(json), 'text/html');
  }

  async function loadReviewBatch(state, batch) {
    if (state.batches.has(batch)) return;
    const url = new URL(state.source);
    url.searchParams.set('page', batch);
    const response = await fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('Review request failed');
    const parsed = reviewPageMarkup(await response.text());
    const list = parsed.querySelector('.hc-reviews-tab__list .hc-reviews__list');
    const cards = list ? reviewCards(list) : [];
    const lastBatch = batch === state.batchCount;
    const ids = cards.map(card => card.querySelector('.hc-widget-card')?.dataset.id);
    if (nativePage(parsed.querySelector('.hc-paging')) !== batch ||
        (lastBatch ? cards.length < 1 || cards.length > state.batchSize : cards.length !== state.batchSize) ||
        ids.some(id => !id) || new Set(ids).size !== cards.length) {
      throw new Error('Review page did not match the requested batch');
    }
    const existingIds = new Set([...state.batches.values()].flat().map(card => card.querySelector('.hc-widget-card')?.dataset.id));
    if (ids.some(id => existingIds.has(id))) throw new Error('Review pages overlap');
    cards.forEach(card => {
      card.querySelectorAll('script, style, iframe, object, embed').forEach(node => node.remove());
      for (const node of [card, ...card.querySelectorAll('*')]) {
        for (const attribute of [...node.attributes]) {
          if (/^on/i.test(attribute.name) || (['href', 'src'].includes(attribute.name) && /^\s*javascript:/i.test(attribute.value))) node.removeAttribute(attribute.name);
        }
      }
    });
    // These are the same card behaviors used by HelpfulCrowd's own page loader.
    const app = window.jQuery;
    if (!app?.fn?.remotify || !app.fn.hc_lightbox || !app.fn.hc_fields_expandify) throw new Error('Review controls are unavailable');
    app(cards).remotify().hc_lightbox().hc_fields_expandify();
    state.batches.set(batch, cards);
    // Grouped products can report a rating count that differs from their review list.
    // The final native batch establishes how many reviews are actually available.
    if (lastBatch) state.total = (batch - 1) * state.batchSize + cards.length;
  }

  function renderReviewPage(list, state) {
    const start = (state.page - 1) * reviewsPerPage;
    const end = Math.min(start + reviewsPerPage, state.total);
    const visible = [];
    for (let index = start; index < end; index++) {
      visible.push(state.batches.get(Math.floor(index / state.batchSize) + 1)[index % state.batchSize]);
    }
    const children = [...state.decorations, ...visible];
    if (children.some((node, index) => list.children[index] !== node) || list.children.length !== children.length) list.replaceChildren(...children);
    state.rendered = visible;
    if (list.nextElementSibling !== state.controls) list.after(state.controls);
    state.controls.hidden = state.total <= reviewsPerPage;
    const pages = Math.ceil(state.total / reviewsPerPage);
    const buttons = state.controls.querySelector('.lmr-review-pages');
    const signature = `${state.page}/${pages}`;
    if (buttons.dataset.pages !== signature) {
      buttons.dataset.pages = signature;
      buttons.replaceChildren();
      function addButton(label, page, ariaLabel) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.page = page;
        button.setAttribute('aria-controls', list.id);
        if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
        else if (page === state.page) button.setAttribute('aria-current', 'page');
        buttons.append(button);
      }
      addButton('‹', state.page - 1, state.controls.dataset.previous);
      const shown = new Set([1, pages, state.page]);
      // Keep the control usable on narrow phones without an unbounded number row.
      if (pages <= 5) for (let page = 1; page <= pages; page++) shown.add(page);
      else if (state.page <= 2) shown.add(2);
      else if (state.page >= pages - 1) shown.add(pages - 1);
      let previous = 0;
      for (const page of [...shown].filter(page => page > 0).sort((a, b) => a - b)) {
        if (page - previous > 1) {
          const ellipsis = document.createElement('span');
          ellipsis.textContent = '…';
          ellipsis.setAttribute('aria-hidden', 'true');
          buttons.append(ellipsis);
        }
        addButton(String(page), page);
        previous = page;
      }
      addButton('›', state.page + 1, state.controls.dataset.next);
    }
    buttons.querySelectorAll('button').forEach(button => {
      const page = Number(button.dataset.page);
      button.disabled = state.loading || page < 1 || page > pages;
    });
    state.controls.setAttribute('aria-busy', String(state.loading));
    const status = state.controls.querySelector('[role="status"]');
    status.hidden = !state.error;
    const message = state.error ? status.dataset.error : '';
    if (status.textContent !== message) status.textContent = message;
  }

  function compactReviews(list) {
    let state = reviewPages.get(list);
    const cards = reviewCards(list);
    if (state && (cards.length !== state.rendered.length || cards.some((card, index) => card !== state.rendered[index]))) {
      // A native sort/filter can replace the cards without replacing their UL.
      state.controls.remove();
      reviewPages.delete(list);
      state = null;
    }
    if (!state) {
      const wrapper = list.closest('.hc-reviews-tab__list');
      wrapper?.classList.remove('lmr-paged-list');
      if (list.nextElementSibling?.classList.contains('lmr-review-pagination')) list.nextElementSibling.remove();
      const paging = wrapper?.querySelector('.hc-paging');
      const link = paging?.querySelector('a.page-link[href]');
      const source = link && new URL(link.href);
      if (source && (source.origin !== 'https://app.helpfulcrowd.com' || !/\/reviews\.js$/.test(source.pathname))) return;
      const totalText = list.closest('.hc-reviews-tab')?.querySelector('.hc-product-rating__review-count')?.textContent;
      const total = source ? Number(totalText?.match(/[\d,]+/)?.[0].replaceAll(',', '')) : cards.length;
      const batch = nativePage(paging);
      // A partial last batch cannot establish the native batch size reliably.
      if (!Number.isInteger(total) || total < cards.length || (source && (batch !== 1 || !cards.length))) return;
      const batchCount = source ? Math.max(batch, ...[...paging.querySelectorAll('a.page-link[href]')].map(link => Number(new URL(link.href).searchParams.get('page')) || 1)) : 1;
      const controls = template.content.querySelector('.lmr-review-pagination').cloneNode(true);
      const decorations = [...list.children].filter(node => !node.classList.contains('hc-card__item'));
      state = {
        batches: new Map([[1, cards]]),
        batchSize: cards.length || 1,
        batchCount,
        total: source ? Math.min(Math.max(total, (batchCount - 1) * cards.length + 1), batchCount * cards.length) : total,
        source: source?.href,
        page: 1,
        controls,
        decorations,
        rendered: cards,
        loading: false,
        error: false
      };
      reviewPages.set(list, state);
      if (!list.id) list.id = `lmr-review-list-${++reviewListId}`;
      if (wrapper) wrapper.classList.add('lmr-paged-list');
      controls.addEventListener('click', async event => {
        const button = event.target.closest('button[data-page]');
        if (!button || button.disabled || state.loading) return;
        const page = Number(button.dataset.page);
        if (page === state.page) return;
        state.loading = true;
        state.error = false;
        renderReviewPage(list, state);
        try {
          const start = (page - 1) * reviewsPerPage;
          const end = Math.min(start + reviewsPerPage, state.total) - 1;
          for (let batch = Math.floor(start / state.batchSize) + 1; batch <= Math.floor(end / state.batchSize) + 1; batch++) await loadReviewBatch(state, batch);
          if (!list.isConnected || reviewPages.get(list) !== state) return;
          const targetPage = Math.min(page, Math.ceil(state.total / reviewsPerPage));
          const targetStart = (targetPage - 1) * reviewsPerPage;
          const targetEnd = Math.min(targetStart + reviewsPerPage, state.total) - 1;
          for (let batch = Math.floor(targetStart / state.batchSize) + 1; batch <= Math.floor(targetEnd / state.batchSize) + 1; batch++) await loadReviewBatch(state, batch);
          state.page = targetPage;
        } catch (error) {
          state.error = true;
        } finally {
          state.loading = false;
          if (list.isConnected && reviewPages.get(list) === state) {
            renderReviewPage(list, state);
            if (!state.error) {
              const first = state.rendered[0];
              first.tabIndex = -1;
              first.focus({ preventScroll: true });
              const header = document.getElementById('site-control');
              const headerHeight = header?.dataset.positioning === 'sticky' ? header.getBoundingClientRect().height : 0;
              first.style.scrollMarginTop = `${headerHeight + 16}px`;
              first.scrollIntoView({ block: 'start', behavior: 'instant' });
            }
          }
        }
      });
    }
    renderReviewPage(list, state);
  }
  function enhance(root) {
    const list = root.querySelector('.hc-reviews-tab');
    if (!list) return;
    document.body.classList.add('lmr-enabled');
    if (!list.querySelector('.lmr-heading')) list.prepend(template.content.querySelector('.lmr-heading').cloneNode(true));
    const media = list.querySelector('.hc-reviews-media');
    const firstPhoto = media?.querySelector('.hc-media__medium');
    if (firstPhoto && !media.querySelector('.lmr-photo-heading')) {
      const heading = template.content.querySelector('.lmr-photo-heading').cloneNode(true);
      const countText = media.querySelector('.hc-reviews-media__image-count')?.textContent.trim() || '';
      const count = countText.match(/\d+/)?.[0];
      heading.querySelector('.lmr-photo-count').textContent = count ? `(${count})` : '';
      heading.querySelector('button').addEventListener('click', event => openPhotos(root, media, 0, event.currentTarget));
      media.prepend(heading);
      media.querySelectorAll('.hc-media__medium').forEach((photo, index) => {
        const thumb = photo.querySelector('img');
        if (index < 4) loadUncroppedThumbnail(thumb);
        photo.addEventListener('click', event => {
          event.stopImmediatePropagation();
          event.preventDefault();
          openPhotos(root, media, index, photo);
        }, true);
        photo.setAttribute('role', 'button');
        photo.tabIndex = 0;
        photo.addEventListener('focus', () => photo.scrollIntoView({ block: 'nearest', inline: 'nearest' }));
        photo.setAttribute('aria-label', `${heading.querySelector('h3').firstChild.textContent.trim()} ${index + 1}`);
        photo.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); photo.click(); }
        });
      });
    }
    if (firstPhoto) photoWarmup.observe(media);
    const reviewList = list.querySelector('.hc-reviews-tab__list');
    list.querySelectorAll('.hc-reviews__list').forEach(compactReviews);
    const count = list.querySelector('.hc-product-rating__review-count')?.textContent.trim();
    if (reviewList && count && !list.querySelector('.lmr-toolbar')) {
      const toolbar = template.content.querySelector('.lmr-toolbar').cloneNode(true);
      const allReviews = toolbar.querySelector('.lmr-all-reviews');
      const total = count.match(/[\d,]+/)?.[0];
      allReviews.textContent = total ? `${allReviews.dataset.label} (${total})` : count;
      reviewList.before(toolbar);
      createFilter(root, toolbar, reviewList, media);
    }
    list.querySelectorAll('.hc-widget-card__date time[datetime]').forEach(time => {
      if (time.nextElementSibling?.classList.contains('lmr-short-date')) return;
      const date = new Date(time.dateTime);
      if (Number.isNaN(date.getTime())) return;
      const short = document.createElement('span');
      short.className = 'lmr-short-date';
      short.textContent = dateFormat.format(date);
      time.after(short);
    });
  }
  function compactBreadcrumbs() {
    document.querySelectorAll('.breadcrumbs > ol').forEach(list => {
      const existingMenu = list.querySelector('.lmr-breadcrumb-menu');
      if (existingMenu) {
        const details = existingMenu.querySelector('details');
        document.addEventListener('click', event => { if (!existingMenu.contains(event.target)) details.open = false; });
        existingMenu.addEventListener('keydown', event => {
          if (event.key === 'Escape') { details.open = false; existingMenu.querySelector('summary').focus(); }
        });
        return;
      }
      const items = [...list.children];
      if (items.length < 3) return;
      const menu = template.content.querySelector('.lmr-breadcrumb-menu').cloneNode(true);
      const details = menu.querySelector('details');
      items.slice(1, -1).forEach(item => {
        item.classList.add('lmr-breadcrumb-parent');
        const source = item.querySelector('a');
        if (!source) return;
        const link = document.createElement('a');
        link.href = source.href;
        link.textContent = source.textContent.trim();
        menu.querySelector('.lmr-breadcrumb-links').append(link);
      });
      items[items.length - 1].title = items[items.length - 1].textContent.trim();
      list.insertBefore(menu, items[1]);
      document.addEventListener('click', event => { if (!menu.contains(event.target)) details.open = false; });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { details.open = false; menu.querySelector('summary').focus(); }
      });
    });
  }
  function attach() {
    compactBreadcrumbs();
    document.querySelectorAll('.alc-product-trust').forEach(section => section.style.setProperty('--lmr-surface', template.dataset.surface));
    document.querySelectorAll('[data-hc="product-tabs"]').forEach(root => {
      if (roots.has(root)) return;
      roots.add(root);
      root.classList.add('lmr-reviews');
      root.style.setProperty('--lmr-surface', template.dataset.surface);
      root.style.setProperty('--lmr-border', template.dataset.border);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; enhance(root); });
      }).observe(root, { childList: true, subtree: true });
      enhance(root);
    });
  }
  attach();
  document.addEventListener('shopify:section:load', attach);
})();
  } catch(e) { console.error(e); }
})();

})();
